<ng-container *ngIf="company && batch">
  <company-info *ngIf="recipient" [company]="batch.recipient" [compact]="true" [truncate]="false" [carbon-footprint]="carbonFootprint"></company-info>
  <ng-container *ngIf="batch.destination; let destination">
    <div class="small" *ngIf="destination.name">{{ destination.name }}</div>
    <div class="micro text-muted" *ngIf="destination.location && !compact">
      {{ destination.location.levels[0].name }}
      {{ destination.location.levels[2] ? '(' + destination.location.levels[2].name + ')' : '' }}
    </div>
  </ng-container>
</ng-container>